import { useMediaQuery } from "@mui/material";
import { useImagePath } from "hooks/useImagePath";
import { friendCenterAssets } from "assets/cdn";
import { Container } from "./styles";

const NoFriendsState = () => {
	const { getImage } = useImagePath("cdn");
	const noFriendsImage = getImage(
		friendCenterAssets.friendInvite.noFriendsState
	);
	const isPortrait = useMediaQuery(
		"(orientation: portrait) and (max-width: 899px)"
	);

	return (
		<Container>
			<img src={noFriendsImage} alt="No friends available image" />
			<p>
				{isPortrait ? (
					<>
						You&apos;ve sent invites to all your
						<br /> current friends! Add new friends
						<br /> in the app to invite them too.
					</>
				) : (
					<>
						You&apos;ve sent invites to all your current friends!
						<br /> Add new friends in the app to invite them too.
					</>
				)}
			</p>
		</Container>
	);
};

export default NoFriendsState;
